/** Projects — create form (RHF + zod + shadcn Form via Refine useForm). */
import { useForm } from "@refinedev/react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { ENTITY_STATUS, createProjectSchema, type CreateProjectInput } from "@aos/shared";

import { Form } from "@/components/ui/form";
import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";

import { PageHeader } from "./_shared";
import { FormGrid, SelectField, TextAreaField, TextField } from "./_form";

export function ProjectCreate() {
  const form = useForm<CreateProjectInput, any, CreateProjectInput>({
    resolver: zodResolver(createProjectSchema),
    defaultValues: {
      name: "",
      status: "active",
      description: "",
      company_id: "",
    },
    refineCoreProps: { resource: "projects", action: "create" },
  });

  const {
    refineCore: { formLoading },
    saveButtonProps,
    control,
  } = form;

  return (
    <div className="mx-auto max-w-3xl space-y-6">
      <PageHeader title="New Project" description="Create a project." />
      <Form {...form}>
        <form onSubmit={saveButtonProps.onClick}>
          <Card>
            <CardHeader>
              <CardTitle className="text-base">Project details</CardTitle>
            </CardHeader>
            <CardContent className="space-y-4">
              <FormGrid>
                <TextField
                  control={control}
                  name="name"
                  label="Name"
                  placeholder="Riverside Tower"
                />
                <SelectField
                  control={control}
                  name="status"
                  label="Status"
                  options={ENTITY_STATUS}
                />
              </FormGrid>
              <TextField
                control={control}
                name="company_id"
                label="Company ID"
                placeholder="company_demo"
                description="Optional — link this project to a company."
              />
              <TextAreaField
                control={control}
                name="description"
                label="Description"
                placeholder="Short description of the project."
              />
            </CardContent>
            <CardFooter className="justify-end">
              <Button type="submit" disabled={formLoading}>
                {formLoading ? "Creating…" : "Create Project"}
              </Button>
            </CardFooter>
          </Card>
        </form>
      </Form>
    </div>
  );
}

export default ProjectCreate;
